import { ChevronRight, FilePlus2, PlusCircle, Settings } from 'lucide-react'
import { useRef } from 'react'
import type { AppLocale } from '../i18n'
import { stringsFor } from '../i18n'

export interface ProjectGalleryProps {
  locale: AppLocale
  onOpenFree: () => void
  onOpenBase: () => void
  onImportProject: (file: File) => void
}

export function ProjectGallery({ locale, onOpenFree, onOpenBase, onImportProject }: ProjectGalleryProps) {
  const strings = stringsFor(locale).gallery
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <main className="ios-gallery-shell">
      <header className="ios-gallery-header">
        <span aria-hidden="true" />
        <h1>{strings.eyebrow}</h1>
        <div className="ios-gallery-actions">
          <button type="button" disabled aria-label={strings.settings} title={strings.settings}><Settings /></button>
          <button type="button" onClick={() => inputRef.current?.click()} aria-label={strings.importProject} title={strings.importProject}><FilePlus2 /></button>
          <button type="button" className="is-accent" onClick={onOpenBase} aria-label={strings.newProject} title={strings.newProject}><PlusCircle /></button>
          <input ref={inputRef} className="file-input" type="file" accept=".forcecad,.framelab,application/zip" onChange={(event) => {
            const file = event.currentTarget.files?.[0]
            if (file) onImportProject(file)
            event.currentTarget.value = ''
          }} />
        </div>
      </header>

      <section className="ios-gallery-content" aria-labelledby="project-list-title">
        <div className="ios-gallery-watermark" aria-hidden="true">F</div>
        <h2 id="project-list-title" className="ios-gallery-section-title">{strings.projects}</h2>
        <button type="button" className="ios-project-row" onClick={onOpenFree}>
          <div className="ios-project-copy">
            <strong>{strings.fixtureTitle}</strong>
            <small>{strings.fixtureSubtitle}</small>
          </div>
          <div className="ios-project-thumbnail" aria-hidden="true">
            <span /><span /><span />
          </div>
          <ChevronRight aria-hidden="true" />
        </button>
      </section>
    </main>
  )
}
